import React from 'react';
import { Modal } from '../../modal';
import PropTypes from 'prop-types';
import { GameSettingsModal } from '../../modal/game-settings-modal';

const GameSettingsModalParent = props => {
    const {
        screen,
        checked,
        onSwitch,
        onRadioSelect,
        buttonIsDisabled,
        onClick,
    } = props;

    return (
        <Modal
            onClick={onClick}
            translation={false}
            buttonIsDisabled={buttonIsDisabled}
            ariaLabel={`${screen} game settings`}
        >
            <GameSettingsModal
                screen={screen}
                checked={checked}
                onSwitch={onSwitch}
                onRadioSelect={onRadioSelect}
            />
        </Modal>
    );
};

GameSettingsModalParent.propTypes = {
    screen: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    toggleSwitch: PropTypes.bool,
    onSwitch: PropTypes.func,
    onRadioSelect: PropTypes.func,
    buttonIsDisabled: PropTypes.bool,
};

export { GameSettingsModalParent };
